// IE 2026 10 17 / ODOO-5800 (Igor 17.10, dev02, M03 «Маркетинговий план · CF» 1coh_001 под чипсами «БЮ: VMS» / «Бренд: Зест»:
// «после открытия отчёта вижу первый кадр, начинаю раскрывать группировки, через 2 с они схлопываются»).
// Замер ботом (handoff-tools/2026-10-17/m03_collapse): первый кадр — строки из ответа widget_open (144 строки), сразу за ним фронт
// шлёт select (mainStore: селектор шапки / Set-без-Get / приём чипса метрик) и через ~2–7 с приходит полный набор (1042 строки) →
// AttrGrid.set_itemsSource пересобирает CollectionView; прежняя свёртка хранилась ПО ИНДЕКСАМ строк (GroupRow) и ПО ССЫЛКЕ на dataItem
// (дерево), а строки пришли новые и в другом числе — ветка «длина отличается» заново применяет дефолт раскладки (_DLRow.isCollapsed),
// и раскрытые пользователем группы схлопываются.
// Здесь — свёртка дерева ПО КЛЮЧУ строки раскладки: _DLRow.row_id + _DLRow.name + _DLRow.where (поля группировки строки:
// leftValue / condition / rightValue — data_layout2.create_where_rows). Снимок перед заменой itemsSource, восстановление после
// дефолтов DL: что пользователь раскрыл / свернул — остаётся, строки без ключа (нет _DLRow) и новые группы — как велит раскладка.
// Чистая логика без Vue и wijmo (юнит — tests/unit/gridKeepExpanded.test.mjs); выключатель fe.ux.gridKeepExpanded (дефолт ВКЛ) —
// в AttrGrid.foldKeep_on.

const _s = (v) => (v === undefined || v === null) ? '' : String(v)

// ключ строки дерева для сопоставления между сборками данных; null — строку сопоставить нельзя (нет меты раскладки)
export function treeRowKey(dataItem) {
    const d = dataItem && dataItem._DLRow
    if (!d || typeof d !== 'object') return null
    const where = Array.isArray(d.where)
        ? d.where.map(w => [_s(w && w.leftValue && w.leftValue.value), _s(w && w.condition), _s(w && w.rightValue && w.rightValue.value)])
        : []
    if (!where.length && !d.row_id && !d.name) return null
    return JSON.stringify([_s(d.row_id), _s(d.name), where])
}

// снимок свёртки строк-групп дерева: ключ → isCollapsed (первая строка с ключом главнее дублей)
export function foldState_snapshot(rows) {
    const m = new Map()
    for (const row of rows || []) {
        if (!row || !row.hasChildren) continue
        const k = treeRowKey(row.dataItem)
        if (k !== null && !m.has(k)) m.set(k, !!row.isCollapsed)
    }
    return m
}

// вернуть свёртку по снимку; строки без ключа или без записи в снимке не трогаются. Возвращает число изменённых строк
export function foldState_restore(rows, snap) {
    if (!snap || !snap.size) return 0
    let n = 0
    for (const row of rows || []) {
        if (!row || !row.hasChildren) continue
        const k = treeRowKey(row.dataItem)
        if (k === null || !snap.has(k)) continue
        const c = snap.get(k)
        if (!!row.isCollapsed === c) continue
        try { row.isCollapsed = c; n++ } catch (e) { /* не tree-строка wijmo */ }
    }
    return n
}
